import { DateType, Holiday, Luggage, ServiceFee, SuburbanFeeData, Vehicle } from "../my-type";
import { authUserData } from ".";
import {
  VehicleService as GeneratedVehicleService,
  callApi,
  configureApiClient,
  fetchWithApiClient,
} from "../api/client";

const configureVehicleApiClient = () => {
  configureApiClient({
    tokenProvider: () => authUserData()?.jwtToken ?? null,
  });
};

/**
 * Get vehicles by team ID (Admin/Lead only)
 */
export const getVehiclesByTeamId = async (teamId: number): Promise<Vehicle[] | null> => {
  try {
    configureVehicleApiClient();
    const data = await callApi(
      () => GeneratedVehicleService.getApiVehicleGetVehiclesByTeamId(teamId),
      "Error fetching vehicles by team ID"
    );
    return data as Vehicle[];
  } catch (error) {
    console.error("Error fetching vehicles by team ID:", error);
    return null;
  }
}

/**
 * Update a single vehicle configuration (Admin/Lead only)
 */
export const updateVehicle = async (teamId: number, vehicle: Vehicle): Promise<boolean> => {
  try {
    configureVehicleApiClient();
    await callApi(
      () => GeneratedVehicleService.putApiVehicleUpdateVehicle(teamId, {
        id: vehicle.id,
        vehicleID: vehicle.vehicleID,
        vehiclename: vehicle.vehiclename,
        peopleLimit: vehicle.peopleLimit,
        luggageSupporting: vehicle.luggageSupporting.map(l => ({
          luggage: {
            size: l.luggage.size,
            discription: l.luggage.discription
          },
          quantity: l.quantity
        })),
        totalLuggageLimit: vehicle.totalLuggageLimit,
        enabled: vehicle.enabled
      } as unknown as import("../generated/api").VehicleDto),
      "Error updating vehicle"
    );
    return true;
  } catch (error) {
    console.error("Error updating vehicle:", error);
    return false;
  }
}

/**
 * Bulk update all vehicles for a team (Admin/Lead only)
 */
export const bulkUpdateVehicles = async (teamId: number, vehicles: Vehicle[]): Promise<boolean> => {
  try {
    configureVehicleApiClient();
    await callApi(
      () => GeneratedVehicleService.putApiVehicleBulkUpdateVehicles(
        teamId,
        vehicles.map(vehicle => ({
        id: vehicle.id,
        vehicleID: vehicle.vehicleID,
        vehiclename: vehicle.vehiclename,
        peopleLimit: vehicle.peopleLimit,
        luggageSupporting: vehicle.luggageSupporting.map(l => ({
          luggage: {
            size: l.luggage.size,
            discription: l.luggage.discription
          },
          quantity: l.quantity
        })),
        totalLuggageLimit: vehicle.totalLuggageLimit,
        enabled: vehicle.enabled
      })) as unknown as Array<import("../generated/api").VehicleDto>
      ),
      "Error bulk updating vehicles"
    );
    return true;
  } catch (error) {
    console.error("Error bulk updating vehicles:", error);
    return false;
  }
}

// export const getVehiclesTypes = () => {
//   let vehicles: Vehicle[] = [];

//   vehicles.push({
//     id: 0,
//     vehicleID: 'T01',
//     vehiclename: '多元計程車',
//     peopleLimit: 4,
//     luggageSupporting: [
//       { luggage: { size: 20, discription: '20吋以下行李' }, quantity: 3 },
//       { luggage: { size: 25, discription: '21~25吋行李' }, quantity: 2 },
//       { luggage: { size: 27, discription: '26~27吋行李' }, quantity: 2 },
//       { luggage: { size: 29, discription: '28~29吋行李' }, quantity: 1 },
//     ],
//     totalLuggageLimit: 3,
//     enabled: false
//   })

//   vehicles.push({
//     id: 1,
//     vehicleID: 'T02',
//     vehiclename: '小黃計程車',
//     peopleLimit: 4,
//     luggageSupporting: [
//       { luggage: { size: 20, discription: '20吋以下行李' }, quantity: 3 },
//       { luggage: { size: 25, discription: '21~25吋行李' }, quantity: 2 },
//       { luggage: { size: 27, discription: '26~27吋行李' }, quantity: 2 },
//       { luggage: { size: 29, discription: '28~29吋行李' }, quantity: 1 },
//     ],
//     totalLuggageLimit: 3,
//     enabled: false

//   })

//   vehicles.push({
//     id: 2,
//     vehicleID: 'V04',
//     vehiclename: '機場四人專車',
//     peopleLimit: 4,
//     luggageSupporting: [
//       { luggage: { size: 20, discription: '20吋以下行李' }, quantity: 3 },
//       { luggage: { size: 25, discription: '21~25吋行李' }, quantity: 2 },
//       { luggage: { size: 27, discription: '26~27吋行李' }, quantity: 2 },
//       { luggage: { size: 29, discription: '28~29吋行李' }, quantity: 1 },
//     ],
//     totalLuggageLimit: 3,
//     enabled: true
//   })

//   vehicles.push({
//     id: 3,
//     vehicleID: 'V06',
//     vehiclename: '機場六人專車',
//     peopleLimit: 6,
//     luggageSupporting: [
//       { luggage: { size: 20, discription: '20吋以下行李' }, quantity: 8 },
//       { luggage: { size: 25, discription: '21~25吋行李' }, quantity: 6 },
//       { luggage: { size: 27, discription: '26~27吋行李' }, quantity: 5 },
//       { luggage: { size: 29, discription: '28~29吋行李' }, quantity: 4 },
//     ],
//     totalLuggageLimit: 6,
//     enabled: true
//   })

//   vehicles.push({
//     id: 4,
//     vehicleID: 'B04',
//     vehiclename: '機場商務專車',
//     peopleLimit: 4,
//     luggageSupporting: [
//       { luggage: { size: 20, discription: '20吋以下行李' }, quantity: 3 },
//       { luggage: { size: 25, discription: '21~25吋行李' }, quantity: 2 },
//       { luggage: { size: 27, discription: '26~27吋行李' }, quantity: 2 },
//       { luggage: { size: 29, discription: '28~29吋行李' }, quantity: 1 },
//     ],
//     totalLuggageLimit: 3,
//     enabled: true
//   })


//   return vehicles;


// }

export const getSuburbanFeeData = async (city: string, airportID: string, teamCode: string): Promise<SuburbanFeeData[]> => {
  try {
    configureVehicleApiClient();
    const query = new URLSearchParams({
      city,
      airportID,
      teamCode,
    });
    const response = await fetchWithApiClient(`/api/Vehicle/GetSuburbanFeeData?${query.toString()}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      return [];
    }
    return (await response.json()) as SuburbanFeeData[];

  } catch (error) {
    console.log(error);
    return [];
  }
}

// Legacy hardcoded suburban fee data - kept for reference/migration
export const getSuburbanFeeDataLegacy = (city: string, airportID: string): (SuburbanFeeData[]) => {
  switch (city) {

    case '台北市':
      //文山區
      let fartherStreetsWenshan = ['貓空', '指南路三段', '老泉街26巷', '老泉街45巷', '新光路二段', '萬壽路'];
      //士林區
      let fartherStreetsShilin = ['永公路', '至善路三段', '芝玉路', '仰德大道', '菁山路', '光華路', '中山北路七段', '新安路', '平菁街'];
      //北投區
      let fartherStreetsBeitou = ['紗帽路', '東昇路', '陽投公路', '湖底路', '中興路', '湖山路', '陽金公路', '格致路', '陽明路', '剩麗街',
        '建國街', '新園街', '菁山路', '竹子湖路', '登山路', '復興三路', '秀山路74巷', '秀山路85巷'];
      //內湖區
      let fartherStreetsNeihu = ['大湖山莊街', '大湖街', '康湖路', '安泰街', '康樂街'];
      //信義區
      let fartherStreetsXinyi = ['祥雲街', '紫雲街', '瑞雲街', '景雲街'];

      if (airportID === 'TPE') {
        return [{
          city: '台北市', airportID: 'TPE', suburbanFee: [
            {
              city: '台北市', region: '松山區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台北市', region: '大安區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台北市', region: '中山區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台北市', region: '中正區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台北市', region: '大同區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台北市', region: '萬華區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台北市', region: '文山區', basicPrice: 300, fartherPrice: 500,
              fartherStreets: fartherStreetsWenshan
            }, {
              city: '台北市', region: '士林區', basicPrice: 0, fartherPrice: 300,
              fartherStreets: fartherStreetsShilin
            }, {
              city: '台北市', region: '北投區', basicPrice: 300, fartherPrice: 500,
              fartherStreets: fartherStreetsBeitou
            }, {
              city: '台北市', region: '內湖區', basicPrice: 0, fartherPrice: 200,
              fartherStreets: fartherStreetsNeihu
            }, {
              city: '台北市', region: '南港區', basicPrice: 200, fartherPrice: 0,
              fartherStreets: []
            }, {
              city: '台北市', region: '信義區', basicPrice: 0, fartherPrice: 200,
              fartherStreets: fartherStreetsXinyi
            }
          ]
        }]
      } else if (airportID === 'TSA') {
        return [{
          city: '台北市', airportID: 'TSA', suburbanFee: [{
            city: '台北市', region: '文山區', basicPrice: 50, fartherPrice: 300,
            fartherStreets: fartherStreetsWenshan
          }, {
            city: '台北市', region: '士林區', basicPrice: 0, fartherPrice: 300,
            fartherStreets: fartherStreetsShilin
          },
          {
            city: '台北市', region: '北投區', basicPrice: 50, fartherPrice: 300,
            fartherStreets: fartherStreetsBeitou
          },
          {
            city: '台北市', region: '內湖區', basicPrice: 0, fartherPrice: 200,
            fartherStreets: fartherStreetsNeihu
          }
          ]
        }]
      } else {
        return [];
      }

    case '新北市':

      //汐止區
      let fartherStreetsXizhi = ['八連路', '汐萬路三段', '忠二街', '忠三街', '湖前路', '湖東街', '伯爵街', '翠峰街', '瑞松街',
        '夢湖路', '汐平路', '茄福街', '勤進路', '秀山路', '水源路二段', '汐碇路', '東勢街', '舊莊街二段'];
      //淡水區
      //let fartherStreetsTamsui = [''];
      //新店區
      let fartherStreetsXinDian = ['華城路', '新潭路', '安泰路', '安一路', '雙城路', '玫瑰路', '裕合街', '和成街',
        '錦秀路', '安康路三段', '如意街', '富貴街', '吉祥街', '僑信路', '黎明路', '僑義路', '僑愛路', '車子路', '安忠路',
        '大學街', '青山路', '安華路', '頂城三街', '莒光路', '永業路', '華潭街'];

      //山峽區
      let fartherStreetsSanxia = ['成福路', '竹崙路', '紫微路', '介壽路二段', '介壽路一段276巷', '白雞路', '添福路'];

      if (airportID === 'TPE') {
        return [{
          city: '新北市', airportID: 'TPE', suburbanFee: [
            {
              city: '新北市', region: '板橋區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '三重區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '中和區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '永和區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '新莊區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '樹林區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '鶯歌區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '瑞芳區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '土城區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '蘆洲區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '五股區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '泰山區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '林口區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '汐止區', basicPrice: 300, fartherPrice: 500,
              fartherStreets: fartherStreetsXizhi
            },
            {
              city: '新北市', region: '淡水區', basicPrice: 500, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '深坑區', basicPrice: 500, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '新店區', basicPrice: 200, fartherPrice: 500,
              fartherStreets: fartherStreetsXinDian
            },
            {
              city: '新北市', region: '三峽區', basicPrice: 0, fartherPrice: 300,
              fartherStreets: fartherStreetsSanxia
            },
            {
              city: '新北市', region: '瑞芳區', basicPrice: 500, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '石碇區', basicPrice: 500, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '坪林區', basicPrice: 800, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '三芝區', basicPrice: 800, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '石門區', basicPrice: 800, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '平溪區', basicPrice: 800, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '雙溪區', basicPrice: 800, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '貢寮區', basicPrice: 800, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '金山區', basicPrice: 800, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '萬里區', basicPrice: 800, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '烏來區', basicPrice: 800, fartherPrice: 0,
              fartherStreets: []
            }
          ]
        }]
      } else if (airportID === 'TSA') {
        return [{
          city: '新北市', airportID: 'TSA', suburbanFee: [
            {
              city: '新北市', region: '中和區', basicPrice: 50, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '永和區', basicPrice: 50, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '板橋區', basicPrice: 50, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '新莊區', basicPrice: 50, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '三重區', basicPrice: 50, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '新店區', basicPrice: 100, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '深坑區', basicPrice: 100, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '土城區', basicPrice: 100, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '樹林區', basicPrice: 100, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '五股區', basicPrice: 100, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '泰山區', basicPrice: 100, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '蘆洲區', basicPrice: 100, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '三峽區', basicPrice: 150, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '鶯歌區', basicPrice: 150, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '淡水區', basicPrice: 150, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '瑞芳區', basicPrice: 500, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '石碇區', basicPrice: 500, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '坪林區', basicPrice: 800, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '三芝區', basicPrice: 800, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '石門區', basicPrice: 800, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '平溪區', basicPrice: 800, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '雙溪區', basicPrice: 800, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '貢寮區', basicPrice: 800, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '金山區', basicPrice: 800, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '萬里區', basicPrice: 800, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '新北市', region: '烏來區', basicPrice: 800, fartherPrice: 0,
              fartherStreets: []
            }
          ]
        }]
      } else {
        return [];
      }

    case '桃園市':
      if (airportID === 'TPE') {
        return [{
          city: '桃園市', airportID: 'TPE', suburbanFee: [
            {
              city: '桃園市', region: '大園區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '桃園市', region: '蘆竹區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '桃園市', region: '龜山區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '桃園市', region: '觀音區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '桃園市', region: '中壢區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '桃園市', region: '桃園區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '桃園市', region: '八德區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '桃園市', region: '新屋區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '桃園市', region: '楊梅區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '桃園市', region: '平鎮區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '桃園市', region: '龍潭區', basicPrice: 300, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '桃園市', region: '大溪區', basicPrice: 300, fartherPrice: 0,
              fartherStreets: []
            }
          ]
        }]
      } else {
        return [];
      }

    case '宜蘭縣':
      if (airportID === 'TPE') {
        return [{
          city: '宜蘭縣', airportID: 'TPE', suburbanFee: [{
            city: '宜蘭縣', region: '宜蘭市', basicPrice: 0, fartherPrice: 0,
            fartherStreets: []
          },
          {
            city: '宜蘭縣', region: '礁溪鄉', basicPrice: 0, fartherPrice: 0,
            fartherStreets: []
          },
          {
            city: '宜蘭縣', region: '羅東鎮', basicPrice: 300, fartherPrice: 0,
            fartherStreets: []
          },
          {
            city: '宜蘭縣', region: '蘇澳鎮', basicPrice: 300, fartherPrice: 0,
            fartherStreets: []
          }]
        }];
      } else if (airportID === 'TSA') {
        return [{
          city: '宜蘭縣', airportID: 'TSA', suburbanFee: [
            {
              city: '宜蘭縣', region: '宜蘭市', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '宜蘭縣', region: '礁溪鄉', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '宜蘭縣', region: '羅東鎮', basicPrice: 300, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '宜蘭縣', region: '蘇澳鎮', basicPrice: 300, fartherPrice: 0,
              fartherStreets: []
            }
          ]
        }];
      } else {
        return [];
      }

    case '苗栗縣':
      if (airportID === 'TPE') {
        return [{
          city: '苗栗縣', airportID: 'TPE', suburbanFee: [
            {
              city: '苗栗縣', region: '苗栗市', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            }
          ]
        }];
      }
      else {
        return [];
      }

    case '台中市':
      if (airportID === 'TPE') {
        return [{
          city: '台中市', airportID: 'TPE', suburbanFee: [
            {
              city: '台中市', region: '大甲區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台中市', region: '大安區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台中市', region: '外埔區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台中市', region: '后里區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台中市', region: '清水區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台中市', region: '神岡區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台中市', region: '豐原區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台中市', region: '石岡區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台中市', region: '梧棲區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台中市', region: '沙鹿區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台中市', region: '大雅區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台中市', region: '潭子區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台中市', region: '北屯區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台中市', region: '龍井區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台中市', region: '西屯區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台中市', region: '北屯區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台中市', region: '大肚區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台中市', region: '南屯區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台中市', region: '北區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台中市', region: '西區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台中市', region: '東區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台中市', region: '南區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台中市', region: '大里區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台中市', region: '太平區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台中市', region: '烏日區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            }
          ]
        }];
      } else {
        return [];
      }

    case '彰化縣':
      if (airportID === 'TPE') {
        return [{
          city: '彰化縣', airportID: 'TPE', suburbanFee: [
            {
              city: '彰化縣', region: '彰化市', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            }
          ]
        }];
      } else {
        return [];
      }

    case '雲林縣':
      if (airportID === 'TPE') {
        return [{
          city: '雲林縣', airportID: 'TPE', suburbanFee: [
            {
              city: '雲林縣', region: '西螺鎮', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '雲林縣', region: '莿桐鄉', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '雲林縣', region: '虎尾鎮', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '雲林縣', region: '斗六市', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '雲林縣', region: '斗南鎮', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            }
          ]
        }];
      } else {
        return [];
      }

    case '嘉義市':
      if (airportID === 'TPE') {
        return [{
          city: '嘉義市', airportID: 'TPE', suburbanFee: [
            {
              city: '嘉義市', region: '東區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '嘉義市', region: '西區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            }
          ]
        }];
      }
      else {
        return [];
      }

    case '台南市':
      if (airportID === 'TPE') {
        return [{
          city: '台南市', airportID: 'TPE', suburbanFee: [
            {
              city: '台南市', region: '後壁區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '白河區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '北門區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '學甲區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '鹽水區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '新營區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '柳營區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '東山區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '將軍區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '佳里區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '麻豆區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '下營區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '六甲區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '官田區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '七股區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '西港區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '善化區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '安定區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '新市區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '安南區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '永康區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '新化區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '安平區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '中西區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '北區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '東區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '南區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '仁德區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '歸仁區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            },
            {
              city: '台南市', region: '關廟區', basicPrice: 0, fartherPrice: 0,
              fartherStreets: []
            }
          ]
        }];
      } else {
        return [];
      }

    default:
      return [];

  }
}

// export const getServiceFeeData = () => {
//   let serviceFeeData: ServiceFee[] = [
//     {
//       airportID: 'TPE',
//       basicPrice: [
//         { city: ['台北市', '新北市'], vehicleID: 'T01', price: 1000, pickUpPrice: 100, holidayPrice: 0 },
//         { city: ['台北市', '新北市'], vehicleID: 'T02', price: 1100, pickUpPrice: 100, holidayPrice: 0 },
//         { city: ['台北市', '新北市'], vehicleID: 'V04', price: 1200, pickUpPrice: 100, holidayPrice: 0 },
//         { city: ['台北市', '新北市'], vehicleID: 'V06', price: 1400, pickUpPrice: 100, holidayPrice: 0 },
//         { city: ['台北市', '新北市'], vehicleID: 'B04', price: 1600, pickUpPrice: 100, holidayPrice: 0 },

//         { city: ['基隆市'], vehicleID: 'T01', price: 1600, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['基隆市'], vehicleID: 'T02', price: 1700, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['基隆市'], vehicleID: 'V04', price: 1800, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['基隆市'], vehicleID: 'V06', price: 2100, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['基隆市'], vehicleID: 'B04', price: 2300, pickUpPrice: 0, holidayPrice: 0 },

//         { city: ['宜蘭縣'], vehicleID: 'T01', price: 2300, pickUpPrice: 0, holidayPrice: 300 },
//         { city: ['宜蘭縣'], vehicleID: 'T02', price: 2400, pickUpPrice: 0, holidayPrice: 300 },
//         { city: ['宜蘭縣'], vehicleID: 'V04', price: 2500, pickUpPrice: 0, holidayPrice: 300 },
//         { city: ['宜蘭縣'], vehicleID: 'V06', price: 2900, pickUpPrice: 0, holidayPrice: 300 },
//         { city: ['宜蘭縣'], vehicleID: 'B04', price: 3200, pickUpPrice: 0, holidayPrice: 300 },

//         { city: ['花蓮縣'], vehicleID: 'T01', price: 6000, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['花蓮縣'], vehicleID: 'T02', price: 6200, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['花蓮縣'], vehicleID: 'V04', price: 6400, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['花蓮縣'], vehicleID: 'V06', price: 7000, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['花蓮縣'], vehicleID: 'B04', price: 7200, pickUpPrice: 0, holidayPrice: 0 },

//         { city: ['桃園市'], vehicleID: 'T01', price: 1000, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['桃園市'], vehicleID: 'T02', price: 1100, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['桃園市'], vehicleID: 'V04', price: 1200, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['桃園市'], vehicleID: 'V06', price: 1500, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['桃園市'], vehicleID: 'B04', price: 1800, pickUpPrice: 0, holidayPrice: 0 },

//         { city: ['新竹市'], vehicleID: 'T01', price: 1500, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['新竹市'], vehicleID: 'T02', price: 1600, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['新竹市'], vehicleID: 'V04', price: 1700, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['新竹市'], vehicleID: 'V06', price: 2000, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['新竹市'], vehicleID: 'B04', price: 2200, pickUpPrice: 0, holidayPrice: 0 },

//         { city: ['苗栗縣'], vehicleID: 'T01', price: 2000, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['苗栗縣'], vehicleID: 'T02', price: 2100, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['苗栗縣'], vehicleID: 'V04', price: 2200, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['苗栗縣'], vehicleID: 'V06', price: 2600, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['苗栗縣'], vehicleID: 'B04', price: 2800, pickUpPrice: 0, holidayPrice: 0 },

//         { city: ['台中市'], vehicleID: 'T01', price: 2500, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['台中市'], vehicleID: 'T02', price: 2600, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['台中市'], vehicleID: 'V04', price: 2700, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['台中市'], vehicleID: 'V06', price: 3000, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['台中市'], vehicleID: 'B04', price: 3200, pickUpPrice: 0, holidayPrice: 0 },

//         { city: ['彰化縣'], vehicleID: 'T01', price: 2700, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['彰化縣'], vehicleID: 'T02', price: 2800, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['彰化縣'], vehicleID: 'V04', price: 2900, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['彰化縣'], vehicleID: 'V06', price: 3300, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['彰化縣'], vehicleID: 'B04', price: 3600, pickUpPrice: 0, holidayPrice: 0 },

//         { city: ['雲林縣'], vehicleID: 'T01', price: 3400, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['雲林縣'], vehicleID: 'T02', price: 3500, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['雲林縣'], vehicleID: 'V04', price: 3600, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['雲林縣'], vehicleID: 'V06', price: 4000, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['雲林縣'], vehicleID: 'B04', price: 4200, pickUpPrice: 0, holidayPrice: 0 },

//         { city: ['嘉義市'], vehicleID: 'T01', price: 4000, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['嘉義市'], vehicleID: 'T02', price: 4200, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['嘉義市'], vehicleID: 'V04', price: 4300, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['嘉義市'], vehicleID: 'V06', price: 4700, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['嘉義市'], vehicleID: 'B04', price: 5000, pickUpPrice: 0, holidayPrice: 0 },

//         { city: ['台南市'], vehicleID: 'T01', price: 4600, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['台南市'], vehicleID: 'T02', price: 4700, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['台南市'], vehicleID: 'V04', price: 4800, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['台南市'], vehicleID: 'V06', price: 5600, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['台南市'], vehicleID: 'B04', price: 6000, pickUpPrice: 0, holidayPrice: 0 },

//       ],
//     },
//     {
//       airportID: 'TSA',
//       basicPrice: [
//         { city: ['台北市', '新北市'], vehicleID: 'T01', price: 750, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['台北市', '新北市'], vehicleID: 'T02', price: 800, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['台北市', '新北市'], vehicleID: 'V04', price: 900, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['台北市', '新北市'], vehicleID: 'V06', price: 1100, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['台北市', '新北市'], vehicleID: 'B04', price: 1300, pickUpPrice: 0, holidayPrice: 0 },
//         { city: ['宜蘭縣'], vehicleID: 'T01', price: 1700, pickUpPrice: 0, holidayPrice: 300 },
//         { city: ['宜蘭縣'], vehicleID: 'T02', price: 1800, pickUpPrice: 0, holidayPrice: 300 },
//         { city: ['宜蘭縣'], vehicleID: 'V04', price: 1900, pickUpPrice: 0, holidayPrice: 300 },
//         { city: ['宜蘭縣'], vehicleID: 'V06', price: 2300, pickUpPrice: 0, holidayPrice: 300 },
//         { city: ['宜蘭縣'], vehicleID: 'B04', price: 2500, pickUpPrice: 0, holidayPrice: 300 }
//       ],
//     },
//   ];

//   const serviceFeeDataJSON = JSON.stringify(serviceFeeData);

//   console.log(serviceFeeDataJSON);

//   return serviceFeeData;
// }

//export const getVehiclesTypes = () => {

//let vehicles: Vehicle[] = [];

// vehicles.push({
//   id: 0,
//   vehicleID: 'T01',
//   vehiclename: '經濟四人座',
//   peopleLimit: 2,
//   luggageSupporting: [
//     { luggage: { size: 28, discription: '28吋行李' }, quantity: 2 },
//   ],
//   totalLuggageLimit: 3,
//   enabled: true
// })

// vehicles.push({
//   id: 1,
//   vehicleID: 'T02',
//   vehiclename: '舒適五人座',
//   peopleLimit: 4,
//   luggageSupporting: [
//     { luggage: { size: 26, discription: '26吋行李' }, quantity: 3 },
//     { luggage: { size: 28, discription: '28吋行李' }, quantity: 2 },
//   ],
//   totalLuggageLimit: 3,
//   enabled: true

// })

// vehicles.push({
//   id: 2,
//   vehicleID: 'V04',
//   vehiclename: '休旅五人座',
//   peopleLimit: 4,
//   luggageSupporting: [
//     { luggage: { size: 26, discription: '26吋行李' }, quantity: 4 },
//     { luggage: { size: 28, discription: '28吋行李' }, quantity: 3 },
//   ],
//   totalLuggageLimit: 3,
//   enabled: true
// })

// vehicles.push({
//   id: 3,
//   vehicleID: 'V06',
//   vehiclename: '舒適八人座',
//   peopleLimit: 7,
//   luggageSupporting: [
//     { luggage: { size: 26, discription: '26吋行李' }, quantity: 7 },
//     { luggage: { size: 28, discription: '28吋行李' }, quantity: 6 },
//   ],
//   totalLuggageLimit: 6,
//   enabled: true
// })

// vehicles.push({
//   id: 4,
//   vehicleID: 'B04',
//   vehiclename: '豪華賓士BENZ九人座',
//   peopleLimit: 8,
//   luggageSupporting: [
//     { luggage: { size: 26, discription: '26吋行李' }, quantity: 7 },
//     { luggage: { size: 28, discription: '28吋行李' }, quantity: 6 },
//   ],
//   totalLuggageLimit: 3,
//   enabled: true
// })


// return vehicles;


//}

// export const getLuggageTypes = () => {
//   let luggageTypes: Luggage[] = [];

//   luggageTypes.push({
//     size: 20,
//     discription: '20吋以下行李'
//   })

//   luggageTypes.push({
//     size: 25,
//     discription: '21~25吋行李'
//   })

//   luggageTypes.push({
//     size: 27,
//     discription: '26~27吋行李'
//   })

//   luggageTypes.push({
//     size: 29,
//     discription: '28~29吋行李'
//   })

//   return luggageTypes;

// }

export const getLuggageTypes = () => {
  let luggageTypes: Luggage[] = [];

  luggageTypes.push({
    size: 26,
    discription: '26吋(含)以下行李'
  })

  luggageTypes.push({
    size: 28,
    discription: '28吋(含)以上行李'
  })



  return luggageTypes;

}

export const checkDateType = async (varDate: Date) => {
  try {
    configureVehicleApiClient();
    const data = await callApi(
      () => GeneratedVehicleService.getApiVehicleHolidays(),
      "Failed to fetch holidays"
    );
    let holidays: Holiday[] = data as Holiday[];
    let dMinusTwo = new Date(varDate);
    dMinusTwo.setDate(varDate.getDate() - 2);
    let checkIndex = holidays.findIndex(value => value.date === varDate.toISOString().substring(0, 10).replaceAll('-', ''));
    let checkIndexForMinusTwo = holidays.findIndex(value => value.date === dMinusTwo.toISOString().substring(0, 10).replaceAll('-', ''));

    if (checkIndex !== -1) {
      if (checkIndexForMinusTwo !== -1) {
        return DateType.LastDayOfVacation;
      } else {
        return DateType.Holiday;
      }
    } else {
      return DateType.Working;
    }

  } catch (error) {
    console.log(error);
    throw error;
  }
}

// ============================================
// TeamVehicle CRUD API Functions
// ============================================

export interface TeamVehicle {
  id: number;
  teamId: number | null;
  vehicleID: string;
  vehicleName: string;
  peopleLimit: number;
  totalLuggageLimit: number;
  enabled: boolean;
  displayOrder: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  luggageSupporting: TeamVehicleLuggage[];
  team?: {
    id: number;
    name: string;
    code: string;
  };
}

export interface TeamVehicleLuggage {
  id: number;
  teamVehicleId: number;
  luggageSize: number;
  luggageDescription: string | null;
  quantity: number;
}

export interface TeamVehicleCreateRequest {
  teamId: number | null;
  vehicleID: string;
  vehicleName: string;
  peopleLimit: number;
  totalLuggageLimit: number;
  enabled: boolean;
  displayOrder: number;
  isActive: boolean;
}

export interface TeamVehicleUpdateRequest extends TeamVehicleCreateRequest { }

export interface TeamVehicleLuggageCreateRequest {
  teamVehicleId: number;
  luggageSize: number;
  luggageDescription?: string;
  quantity: number;
}

export interface TeamVehicleLuggageUpdateRequest {
  luggageSize: number;
  luggageDescription?: string;
  quantity: number;
}

/**
 * Get all TeamVehicle records with optional filtering by TeamId (Admin/Lead only)
 */
export const getAllTeamVehicles = async (teamId?: number): Promise<TeamVehicle[] | null> => {
  try {
    configureVehicleApiClient();
    const data = await callApi(
      () => GeneratedVehicleService.getApiVehicleGetAllTeamVehicles(teamId),
      "Error fetching all team vehicles"
    );
    return data as TeamVehicle[];
  } catch (error) {
    console.error("Error fetching all team vehicles:", error);
    return null;
  }
}

/**
 * Get a single TeamVehicle by ID (Admin/Lead only)
 */
export const getTeamVehicle = async (id: number): Promise<TeamVehicle | null> => {
  try {
    configureVehicleApiClient();
    const data = await callApi(
      () => GeneratedVehicleService.getApiVehicleGetTeamVehicle(id),
      "Error fetching team vehicle"
    );
    return data as TeamVehicle;
  } catch (error) {
    console.error("Error fetching team vehicle:", error);
    return null;
  }
}

/**
 * Create a new TeamVehicle record (Admin/Lead only)
 */
export const createTeamVehicle = async (request: TeamVehicleCreateRequest): Promise<TeamVehicle | null> => {
  try {
    configureVehicleApiClient();
    const data = await callApi(
      () => GeneratedVehicleService.postApiVehicleCreateTeamVehicle(request as unknown as import("../generated/api").TeamVehicleCreateRequest),
      "Error creating team vehicle"
    );
    return data as TeamVehicle;
  } catch (error) {
    console.error("Error creating team vehicle:", error);
    return null;
  }
}

/**
 * Update an existing TeamVehicle record (Admin/Lead only)
 */
export const updateTeamVehicle = async (id: number, request: TeamVehicleUpdateRequest): Promise<TeamVehicle | null> => {
  try {
    configureVehicleApiClient();
    const data = await callApi(
      () => GeneratedVehicleService.putApiVehicleUpdateTeamVehicle(id, request as unknown as import("../generated/api").TeamVehicleUpdateRequest),
      "Error updating team vehicle"
    );
    return data as TeamVehicle;
  } catch (error) {
    console.error("Error updating team vehicle:", error);
    return null;
  }
}

/**
 * Delete a TeamVehicle record (Admin/Lead only)
 */
export const deleteTeamVehicle = async (id: number): Promise<boolean> => {
  try {
    configureVehicleApiClient();
    await callApi(
      () => GeneratedVehicleService.deleteApiVehicleDeleteTeamVehicle(id),
      "Error deleting team vehicle"
    );
    return true;
  } catch (error) {
    console.error("Error deleting team vehicle:", error);
    return false;
  }
}

// ============================================
// TeamVehicleLuggage CRUD API Functions
// ============================================

/**
 * Get all luggage configurations for a specific TeamVehicle (Admin/Lead only)
 */
export const getTeamVehicleLuggages = async (teamVehicleId: number): Promise<TeamVehicleLuggage[] | null> => {
  try {
    configureVehicleApiClient();
    const data = await callApi(
      () => GeneratedVehicleService.getApiVehicleGetTeamVehicleLuggages(teamVehicleId),
      "Error fetching team vehicle luggages"
    );
    return data as TeamVehicleLuggage[];
  } catch (error) {
    console.error("Error fetching team vehicle luggages:", error);
    return null;
  }
}

/**
 * Get a single TeamVehicleLuggage by ID (Admin/Lead only)
 */
export const getTeamVehicleLuggage = async (id: number): Promise<TeamVehicleLuggage | null> => {
  try {
    configureVehicleApiClient();
    const data = await callApi(
      () => GeneratedVehicleService.getApiVehicleGetTeamVehicleLuggage(id),
      "Error fetching team vehicle luggage"
    );
    return data as TeamVehicleLuggage;
  } catch (error) {
    console.error("Error fetching team vehicle luggage:", error);
    return null;
  }
}

/**
 * Create a new luggage configuration for a TeamVehicle (Admin/Lead only)
 */
export const createTeamVehicleLuggage = async (request: TeamVehicleLuggageCreateRequest): Promise<TeamVehicleLuggage | null> => {
  try {
    configureVehicleApiClient();
    const data = await callApi(
      () => GeneratedVehicleService.postApiVehicleCreateTeamVehicleLuggage(request as unknown as import("../generated/api").TeamVehicleLuggageCreateRequest),
      "Error creating team vehicle luggage"
    );
    return data as TeamVehicleLuggage;
  } catch (error) {
    console.error("Error creating team vehicle luggage:", error);
    return null;
  }
}

/**
 * Update an existing luggage configuration (Admin/Lead only)
 */
export const updateTeamVehicleLuggage = async (id: number, request: TeamVehicleLuggageUpdateRequest): Promise<TeamVehicleLuggage | null> => {
  try {
    configureVehicleApiClient();
    const data = await callApi(
      () => GeneratedVehicleService.putApiVehicleUpdateTeamVehicleLuggage(id, request as unknown as import("../generated/api").TeamVehicleLuggageUpdateRequest),
      "Error updating team vehicle luggage"
    );
    return data as TeamVehicleLuggage;
  } catch (error) {
    console.error("Error updating team vehicle luggage:", error);
    return null;
  }
}

/**
 * Delete a luggage configuration (Admin/Lead only)
 */
export const deleteTeamVehicleLuggage = async (id: number): Promise<boolean> => {
  try {
    configureVehicleApiClient();
    await callApi(
      () => GeneratedVehicleService.deleteApiVehicleDeleteTeamVehicleLuggage(id),
      "Error deleting team vehicle luggage"
    );
    return true;
  } catch (error) {
    console.error("Error deleting team vehicle luggage:", error);
    return false;
  }
}

/**
 * Bulk update luggage configurations for a TeamVehicle (Admin/Lead only)
 */
export const bulkUpdateTeamVehicleLuggages = async (teamVehicleId: number, luggages: TeamVehicleLuggageCreateRequest[]): Promise<TeamVehicleLuggage[] | null> => {
  try {
    configureVehicleApiClient();
    const data = await callApi(
      () => GeneratedVehicleService.putApiVehicleBulkUpdateTeamVehicleLuggages(
        teamVehicleId,
        luggages as unknown as Array<import("../generated/api").TeamVehicleLuggageCreateRequest>
      ),
      "Error bulk updating team vehicle luggages"
    );
    return data as TeamVehicleLuggage[];
  } catch (error) {
    console.error("Error bulk updating team vehicle luggages:", error);
    return null;
  }
}

// ============================================
// ServiceFee Data API Functions (for Order Creation)
// ============================================


/**
 * Get service fee data for a team, formatted for order creation pricing calculations.
 * This converts the API response to the ServiceFee[] format used by getVehicleFeeWithAddress.
 */
export const getServiceFeeDataForTeam = async (teamId?: number): Promise<ServiceFee[] | null> => {
  try {
    configureVehicleApiClient();
    const data = await callApi(
      () => GeneratedVehicleService.getApiVehicleGetServiceFeeConfigurations(teamId, undefined),
      "Error fetching service fee data for team"
    );
    const configurations = data as ServiceFeeConfiguration[];

    // Convert ServiceFeeConfiguration[] to ServiceFee[] format
    const serviceFees: ServiceFee[] = configurations
      .filter(config => config.isActive)
      .map(config => {
        const prices = config.basicPrices || config.BasicPrices || [];
        return {
          airportID: config.airportID,
          basicPrice: prices
            .filter(price => price.isActive)
            .map(price => ({
              city: price.cities,
              vehicleID: price.vehicleID,
              price: price.price,
              pickUpPrice: price.pickUpPrice,
              holidayPrice: price.holidayPrice
            }))
        };
      });

    return serviceFees;
  } catch (error) {
    console.error("Error fetching service fee data for team:", error);
    return null;
  }
}

// ============================================
// ServiceFee CRUD API Functions
// ============================================

export interface ServiceFeeConfiguration {
  id: number;
  teamId: number | null;
  airportID: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  basicPrices: ServiceFeePrice[];
  // Backend returns BasicPrices (capital B), so we also accept that
  BasicPrices?: ServiceFeePrice[];
  team?: {
    id: number;
    name: string;
    code: string;
  };
}

export interface ServiceFeePrice {
  id: number;
  serviceFeeConfigurationId: number;
  cities: string[];
  vehicleID: string;
  price: number;
  pickUpPrice: number;
  holidayPrice: number;
  displayOrder: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface ServiceFeeConfigurationCreateRequest {
  teamId: number | null;
  airportID: string;
}

export interface ServiceFeeConfigurationUpdateRequest {
  airportID: string;
  isActive: boolean;
}

export interface ServiceFeePriceCreateRequest {
  serviceFeeConfigurationId: number;
  cities: string[];
  vehicleID: string;
  price: number;
  pickUpPrice: number;
  holidayPrice: number;
  displayOrder: number;
}

export interface ServiceFeePriceUpdateRequest {
  cities: string[];
  vehicleID: string;
  price: number;
  pickUpPrice: number;
  holidayPrice: number;
  displayOrder: number;
  isActive: boolean;
}

/**
 * Get all service fee configurations (Admin/Lead only)
 */
export const getServiceFeeConfigurations = async (teamId?: number, airportID?: string): Promise<ServiceFeeConfiguration[] | null> => {
  try {
    configureVehicleApiClient();
    const data = await callApi(
      () => GeneratedVehicleService.getApiVehicleGetServiceFeeConfigurations(teamId, airportID),
      "Error fetching service fee configurations"
    );
    return data as ServiceFeeConfiguration[];
  } catch (error) {
    console.error("Error fetching service fee configurations:", error);
    return null;
  }
}

/**
 * Get a single service fee configuration by ID
 */
export const getServiceFeeConfiguration = async (id: number): Promise<ServiceFeeConfiguration | null> => {
  try {
    configureVehicleApiClient();
    const data = await callApi(
      () => GeneratedVehicleService.getApiVehicleGetServiceFeeConfiguration(id),
      "Error fetching service fee configuration"
    );
    return data as ServiceFeeConfiguration;
  } catch (error) {
    console.error("Error fetching service fee configuration:", error);
    return null;
  }
}

/**
 * Create a new service fee configuration (Admin/Lead only)
 */
export const createServiceFeeConfiguration = async (request: ServiceFeeConfigurationCreateRequest): Promise<ServiceFeeConfiguration | null> => {
  try {
    configureVehicleApiClient();
    const data = await callApi(
      () => GeneratedVehicleService.postApiVehicleCreateServiceFeeConfiguration(request as unknown as import("../generated/api").ServiceFeeConfigurationCreateRequest),
      "Error creating service fee configuration"
    );
    return data as ServiceFeeConfiguration;
  } catch (error) {
    console.error("Error creating service fee configuration:", error);
    return null;
  }
}

/**
 * Update an existing service fee configuration (Admin/Lead only)
 */
export const updateServiceFeeConfiguration = async (id: number, request: ServiceFeeConfigurationUpdateRequest): Promise<ServiceFeeConfiguration | null> => {
  try {
    configureVehicleApiClient();
    const data = await callApi(
      () => GeneratedVehicleService.putApiVehicleUpdateServiceFeeConfiguration(id, request as unknown as import("../generated/api").ServiceFeeConfigurationUpdateRequest),
      "Error updating service fee configuration"
    );
    return data as ServiceFeeConfiguration;
  } catch (error) {
    console.error("Error updating service fee configuration:", error);
    return null;
  }
}

/**
 * Delete a service fee configuration (Admin only)
 */
export const deleteServiceFeeConfiguration = async (id: number): Promise<boolean> => {
  try {
    configureVehicleApiClient();
    await callApi(
      () => GeneratedVehicleService.deleteApiVehicleDeleteServiceFeeConfiguration(id),
      "Error deleting service fee configuration"
    );
    return true;
  } catch (error) {
    console.error("Error deleting service fee configuration:", error);
    return false;
  }
}

/**
 * Create a new service fee price (Admin/Lead only)
 */
export const createServiceFeePrice = async (request: ServiceFeePriceCreateRequest): Promise<ServiceFeePrice | null> => {
  try {
    configureVehicleApiClient();
    const data = await callApi(
      () => GeneratedVehicleService.postApiVehicleCreateServiceFeePrice(request as unknown as import("../generated/api").ServiceFeePriceCreateRequest),
      "Error creating service fee price"
    );
    return data as ServiceFeePrice;
  } catch (error) {
    console.error("Error creating service fee price:", error);
    return null;
  }
}

/**
 * Update an existing service fee price (Admin/Lead only)
 */
export const updateServiceFeePrice = async (id: number, request: ServiceFeePriceUpdateRequest): Promise<ServiceFeePrice | null> => {
  try {
    configureVehicleApiClient();
    const data = await callApi(
      () => GeneratedVehicleService.putApiVehicleUpdateServiceFeePrice(id, request as unknown as import("../generated/api").ServiceFeePriceUpdateRequest),
      "Error updating service fee price"
    );
    return data as ServiceFeePrice;
  } catch (error) {
    console.error("Error updating service fee price:", error);
    return null;
  }
}

/**
 * Delete a service fee price (Admin/Lead only)
 */
export const deleteServiceFeePrice = async (id: number): Promise<boolean> => {
  try {
    configureVehicleApiClient();
    await callApi(
      () => GeneratedVehicleService.deleteApiVehicleDeleteServiceFeePrice(id),
      "Error deleting service fee price"
    );
    return true;
  } catch (error) {
    console.error("Error deleting service fee price:", error);
    return false;
  }
}

/**
 * Bulk update service fee prices for a configuration (Admin/Lead only)
 */
export const bulkUpdateServiceFeePrices = async (configurationId: number, prices: ServiceFeePriceCreateRequest[]): Promise<ServiceFeeConfiguration | null> => {
  try {
    configureVehicleApiClient();
    const data = await callApi(
      () => GeneratedVehicleService.putApiVehicleBulkUpdateServiceFeePrices(
        configurationId,
        prices as unknown as Array<import("../generated/api").ServiceFeePriceCreateRequest>
      ),
      "Error bulk updating service fee prices"
    );
    return data as ServiceFeeConfiguration;
  } catch (error) {
    console.error("Error bulk updating service fee prices:", error);
    return null;
  }
}
